/* EDIT QUIZZ */
export const EDIT_QUIZZ = "EDIT_QUIZZ"
export const EDIT_QUIZZ_SUCCESS = "EDIT_QUIZZ_SUCCESS"
export const EDIT_QUIZZ_CLEAN = "EDIT_QUIZZ_CLEAN"
export const EDIT_QUIZZ_ERROR = "EDIT_QUIZZ_ERROR"
